import { CascadiaColor, CascadiaTypographyStyle } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { useMemo } from "react";
import { mergeProps } from "react-aria";
import { Heading as AriaHeading, HeadingProps } from "react-aria-components";

import { useColors } from "../../../hooks/useColors";
import { getTextStyle } from "../styles";

interface Props extends Omit<HeadingProps, "style"> {
  style?: CascadiaTypographyStyle;
  color?: CascadiaColor;
}

export function _Heading(props: Props) {
  const {
    style = "global/heading-medium",
    color = "text-base",
    ...headingProps
  } = props;

  const colors = useColors();

  const className = useMemo(() => {
    return css(styles.heading, getTextStyle(style), {
      color: colors[color],
    });
  }, [color, colors, style]);

  return <AriaHeading {...mergeProps(headingProps, { className })} />;
}

const styles = {
  heading: css({ margin: 0 }),
};
